import { canRestoreCachedAuthentication } from "./connectivity";
import {
  getLocalCurrentUser,
  hasCachedAuthenticatedUser,
} from "./offlineBoot";

export const AUTH_SESSION_OFFER_KIND = Object.freeze({
  NONE: "none",
  CONTINUE_CACHED: "continue_cached",
  EXPIRED: "expired",
});

/**
 * Resolves onboarding messaging when a cached actor exists but Supabase
 * session is unavailable. Security: continue is only offered when
 * canRestoreCachedAuthentication() is true (effectively offline).
 */
export function resolveAuthSessionOffer({ hasLiveSession = false } = {}) {
  if (hasLiveSession || !hasCachedAuthenticatedUser()) {
    return {
      kind: AUTH_SESSION_OFFER_KIND.NONE,
      cachedUser: null,
      headline: null,
      detail: null,
      displayName: null,
    };
  }

  const cachedUser = getLocalCurrentUser();
  const displayName =
    cachedUser?.employee_name || cachedUser?.email || "your account";

  if (canRestoreCachedAuthentication()) {
    return {
      kind: AUTH_SESSION_OFFER_KIND.CONTINUE_CACHED,
      cachedUser,
      headline: "Continue with saved session",
      detail:
        "Connection is weak. Working offline until sync is available.",
      displayName,
    };
  }

  return {
    kind: AUTH_SESSION_OFFER_KIND.EXPIRED,
    cachedUser,
    headline: "Session expired",
    detail: "Sign in again to continue syncing.",
    displayName,
  };
}
